import React, { useState, useEffect } from 'react';
import Loading from './Loading';
import InformativoFaturamento from './InformativoFaturamento';
import CardFatura from './mobile/CardFatura';
import GridDetalhamentoFaturamento from './web/GridDetalhamentoFaturamento';
import ReceiptOutlinedIcon from '@material-ui/icons/ReceiptOutlined';
import {
    makeStyles,
    AppBar,
    Tabs,
    Tab,
    Typography,
    Box,
    Grid,
    useMediaQuery
} from '@material-ui/core';
import { StatusFaturamentoEnum } from '../enums';

const useStyles = makeStyles(theme => ({
    barraFatura: {
        ' & .MuiButtonBase-root.Mui-selected': {
            color: theme.palette.secondary.main
        },
        ' & .MuiTab-textColorInherit': {
            color: theme.palette.primary.contrastText
        }
    },
    labelFaturaTotal: {
        textTransform: 'uppercase',
        color: 'rgba(0,0,0,0.38)'
    },
    faturaTotal: {
        color: theme.palette.primary.main,
        paddingBottom: '8px'
    },
    recipe: {
        color: '#91C2DF',
        textAlign: 'center',
        paddingBottom: '2px'
    },
    botaoScroll: {
        color: theme.palette.secondary.main
    },
    root: {
        backgroundColor: theme.palette.primary.main,
    }
}));

function TabPanel(
    {
        children,
        value,
        index
    }
) {
    return <Box p={1} hidden={value !== index}>{children}</Box>
}

function AppBarMes(
    {
        listagem_detalhamento_faturamento,
        index,
        handleObterDetalheFaturamento,
        handleBaixarFatura,
        handleCopiarCodigoBarras,
        detalhamento_faturamento_loading
    }
) {
    const classes = useStyles();
    const mobile = useMediaQuery(theme => theme.breakpoints.down('xs'));
    const [value, setValue] = useState(index);

    const obterDados = (index) => {
        const { ano, mes, detalhamento } = listagem_detalhamento_faturamento[index];

        if (detalhamento === null)
            handleObterDetalheFaturamento(ano, mes);
    }

    useEffect(() => {
        obterDados(index);
    });

    const handleChange = (event, newValue) => {
        setValue(newValue);
        obterDados(newValue);
    }

    return (
        <div className={classes.barraFatura}>
            <AppBar position="static" color="default">
                <Tabs value={value}
                    classes={{
                        scrollButtons: classes.botaoScroll,
                        root: classes.root
                    }}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="on"
                    indicatorColor='primary'>
                    {
                        listagem_detalhamento_faturamento.map((item, index) => <Tab key={index}
                            label={item.titulo}
                        />)
                    }
                </Tabs>
            </AppBar>
            {
                listagem_detalhamento_faturamento.map((item, index) =>
                    <TabPanel key={index}
                        value={value}
                        index={index}>
                        {
                            (detalhamento_faturamento_loading === null ||
                                detalhamento_faturamento_loading === true) ?
                                <Loading /> :
                                item.detalhamento &&
                                <>
                                    <Grid container justify="center" alignItems="flex-end">
                                        <Grid item xs={3} className={classes.recipe}>
                                            {item.detalhamento.valorTotal && <ReceiptOutlinedIcon fontSize="large" />}
                                        </Grid>
                                        <Grid item xs={9}>
                                            <Typography
                                                variant='caption'
                                                component="p"
                                                className={classes.labelFaturaTotal}>
                                                {item.detalhamento.valorTotal && 'Total'}
                                            </Typography>
                                            <Typography variant='h4' className={classes.faturaTotal}>
                                                {item.detalhamento.valorTotal && item.detalhamento.valorTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    {
                                        (() => {
                                            let mostrarInformativo = item.detalhamento.faturas.filter(x => x.codigoSituacao === StatusFaturamentoEnum.EM_ATRASO).length > 0;

                                            return <>
                                                {mostrarInformativo && <InformativoFaturamento />}
                                                {
                                                    (() => {
                                                        //if (mobile) {
                                                        if (1 === 1) {
                                                            return (
                                                                <Grid container
                                                                    spacing={2}>
                                                                    {
                                                                        item.detalhamento.faturas.map((fatura, index2) =>
                                                                            <Grid key={index2}
                                                                                item
                                                                                xs={12}>
                                                                                <CardFatura fatura={fatura}
                                                                                    handleBaixarFatura={handleBaixarFatura}
                                                                                    handleCopiarCodigoBarras={handleCopiarCodigoBarras} />
                                                                            </Grid>)
                                                                    }
                                                                </Grid>
                                                            )
                                                        }
                                                        return <GridDetalhamentoFaturamento />
                                                    })()
                                                }
                                            </>
                                        })()
                                    }
                                </>
                        }
                    </TabPanel>)
            }
        </div>);
}

export default AppBarMes;